<template>
  <v-row v-if="loading" justify="center">
    <v-progress-circular
      size="20"
      width="2"
      color="green"
      indeterminate
      class="my-4"
    />
  </v-row>
  <v-row align="center" v-else>
    <v-col cols="2" class="text-truncate">
      {{ cliente.nome }}
    </v-col>
    <v-col cols="1">
      <template v-if="ordine"> # {{ ordine.numero }} </template>
      <template v-else> N/A </template>
    </v-col>
    <v-col cols="1" class="text-truncate">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            {{ data_breve }}
          </span>
        </template>
        {{ data_estesa }}
      </v-tooltip>
    </v-col>
    <v-col cols="2">
      <v-row no-gutters>
        <v-icon class="mr-2" size="18" :color="conteggio.id_contabile ? 'purple' : conteggio.confermato ? 'green' : 'amber'">
          {{conteggio.id_contabile ? 'mdi-cash' : conteggio.confermato ? "mdi-check" : "mdi-clock" }}
        </v-icon>
        <span :class="conteggio.id_contabile ? 'purple--text' : conteggio.confermato ? 'green--text' : 'amber--text'">{{
          conteggio.id_contabile ? 'Contabilizzato' : conteggio.confermato ? "Confermato" : "In corso"
        }}</span>
      </v-row>
      <v-row no-gutters>
        <v-icon size="18" class="mr-2" :color="conteggio.tipo == 1 ? 'blue' : 'purple'">{{ conteggio.tipo == 1 ? "mdi-cart" : "mdi-clipboard-list" }}</v-icon>
        <span :class="conteggio.tipo == 1 ? 'blue--text' : 'purple--text'">{{ conteggio.tipo == 1 ? "Carrello" : "Lista" }}</span>
      </v-row>
    </v-col>
    <v-col cols="1">
      {{ creatore }}
    </v-col>

    <template v-if="conteggio.confermato">
      <v-col cols="1">
        <template v-if="ordine">{{ tot_ordine.toFixed(2) }} €</template>
      </v-col>
      <v-col cols="1"> {{ tot_conteggio.toFixed(2) }} € </v-col>
      <v-col cols="1" :class="discrepanza >= 0 ? 'green--text' : 'red--text'"
        ><template v-if="ordine">
          <span v-if="discrepanza > 0">+</span>
          {{ discrepanza.toFixed(2) }} €</template
        ></v-col
      >
    </template>
    <template v-else>
      <v-col cols="3"> </v-col>
    </template>
    <v-col cols="2">
      <v-btn icon color="green" @click="$refs.nuova_contabile.open()" :disabled="!conteggio.confermato || conteggio.id_contabile">
        <v-icon>mdi-cash</v-icon>
      </v-btn>
      <NuovaContabile
        :ordine_prop="ordine ? ordine.numero.toString() : ''"
        :ordine_id_prop="ordine ? ordine._id.$oid : ''"
        :cliente_prop="cliente.iva"
        :conteggio_prop="conteggio.id"
        :totale_documento="tot_conteggio"
        :tot_iva_documento="tot_iva_conteggio"
        :tot_trasporto_documento="tot_trasporto"
        :tot_iva_trasporto_documento="tot_iva_trasporto"
        ref="nuova_contabile"
        @new_insert="archivia_conteggio()"
        noButton
      />
      <v-btn icon color="blue" @click="$refs.dettaglio_conteggio.open()">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>

      <DettaglioConteggio
        :ordine="ordine"
        :conteggio_prop="conteggio"
        ref="dettaglio_conteggio"
      />
      <v-btn icon color="purple" :disabled="!conteggio.confermato || conteggio.archiviato" @click="archivia_conteggio()">
        <v-icon>mdi-archive-arrow-down</v-icon>
      </v-btn>
      <v-dialog v-model="dialog_elimina" width="400">
        <template v-slot:activator="{ on }">
          <v-btn icon color="red" v-on="on">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="red--text"> Elimina Conteggio </v-card-title>
          <v-card-text> Sei Sicuro? </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              outlined
              color="red"
              @click="elimina_conteggio()"
              :loading="loading_elimina"
              >Elimina</v-btn
            >
            <v-btn text color="grey" @click="dialog_elimina = false"
              >annulla</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import DettaglioConteggio from "./dettaglio_conteggio/conteggio_dettaglio.vue";
import conteggio_element_mixin from "../mixin/conteggio_element_mixin";
import NuovaContabile from "../../Contabili/desktop/nuova_contabile.vue";
export default {
  components: {
    DettaglioConteggio,
    NuovaContabile,
  },
  mixins: [conteggio_element_mixin],
};
</script>